import React from 'react';
import { ServicesSectionDetails } from '../../constants/constants';
import {ServicesImage} from '../../assets/images/index';
import { motion } from 'framer-motion'; 

const Services = () => {
const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: -10 }} // Start slightly above
            animate={{ opacity: 1, y: 0 }}   // Animate to normal position
            transition={{
              delay: index * 0.05, // Faster staggered effect for characters
              duration: 0.3,
              ease: "easeOut",
            }}
            className="inline-block"
          >
            {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
          </motion.span>
        ));
      };

    return (
        <div>
            <motion.div
                className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
                                  style={{
                                    backgroundImage: `url(${ServicesImage})`,
                                    backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
                                    backgroundPosition: 'center', // Keep the image centered
                                  }}
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  transition={{ duration: 1 }}
                                  whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
                                  viewport={{ once: true }} // Triggers animation when in view
                                >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                        {splitTextArray('OUR SERVICES')}
                    </div>
                </div>
            </motion.div>

            <motion.div className='container flex flex-col justify-center items-center py-[100px]'>
                <div>
                    <h4 className='fontText text-[32px] px-[20px] font-semibold mb-[30px] text-center'>
                        Transforming Spaces with Expert Construction Services
                    </h4>
                </div>
                <div className='flex flex-col gap-[20px] items-center max-md:px-[20px]'>
                    <h5 className='fontText text-[18px] font-normal text-center'>
                        {splitTextArray('Whether youre planning a small renovation or a large-scale development, the team at Shree Dattguru Enterprise is here to bring your construction ideas to life. With a commitment to excellence and attention to detail, we provide all kinds of civil construction services that exceed expectations. From groundwork and structural development to finishing touches, we handle every aspect of construction. Browse through our services and find out how we can help create the perfect space for you.')}
                    </h5>
                </div>
            </motion.div>

            <motion.div className='container pb-[100px]'
             initial={{ opacity: 0 }}
             animate={{ opacity: 1 }}
             transition={{ duration: 2, delay: 1.2 }}
             whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
             viewport={{ once: true }}
            >
                <div className='flex flex-wrap max-md:flex-col items-center justify-center gap-[30px] max-md:gap-[40px]'>
                          {ServicesSectionDetails.map((item, index) => (
                            <div key={index} className='max-md:px-[20px] my-[10px] mx-[10px] flex flex-col justify-center items-center'>
                              <div className='transform transition-all duration-300 hover:scale-105'>
                                <img src={item.icon} alt={item.title} className='w-[300px] rounded-[10px] h-[247px]' />
                              </div>
                              <h4 className='text-[24px] font-semibold fontText pt-[22px]'>{item.title}</h4>
                            </div>
                          ))}
                        </div>
            </motion.div>
        </div>
    );
};

export default Services;
